<script>
import { authComputed } from "@/store/helpers";
import NewTracer from "@/components/Tracer/NewTracer.vue";
import NewDevice from "@/components/Device/NewDevice.vue";
import AddParagraph from "@/components/Paragraphs/AddParagraph.vue";
import EditParagraphs from "@/components/Paragraphs/EditParagraphs.vue";
import EditParagraph from "@/components/Paragraphs/EditParagraph.vue";
import NavAdminControlsGeneric from "@/components/Navigation/NavAdminControlsGeneric.vue";
import NavAdminControlsSpecific from "@/components/Navigation/NavAdminControlsSpecific.vue";
import DeleteTracer from "@/components/Tracer/DeleteTracers.vue";
export default {
    name: "Admin",
    components: {
        DeleteTracer,
        NavAdminControlsSpecific,
        NavAdminControlsGeneric,
        AddParagraph,
        NewDevice,
        EditParagraphs,
        EditParagraph,
        NewTracer
    },
    inject: ["GStore"],
    computed: {
        ...authComputed,
    },
    mounted() {
        // Access the id parameter from the route
        const id = this.$route.params.id;
        if (id) {
            // Perform actions based on the id parameter
            console.log("Editing item with id:", id);
        }
    },


    data() {
        return {
            paragraphObj: null,
            slotName: "NewTracer",
            slotNameGeneric: "Tracer",
        };
    },

    methods: {
        handleOption(value) {
            this.slotName = value;
        },
        handleGenericOption(value) {
            this.slotNameGeneric = value;
        },
        handleParagraphObj(value) {
            console.log("handleParagraphObj", value);
            this.paragraphObj = value;
        },
    },
};
</script>

<template>
    <NavAdminControlsGeneric @preferred-option="handleGenericOption"></NavAdminControlsGeneric>
    <NavAdminControlsSpecific :genericOption="this.slotNameGeneric" @preferred-option="handleOption">
    </NavAdminControlsSpecific>
    <br />
    <div class="container">
        <div class="container without-nav">
            <NewTracer v-if="slotName === 'NewTracer'"></NewTracer>
            <DeleteTracer v-if="slotName === 'DeleteTracers'"></DeleteTracer>
            <AddParagraph v-if="slotName === 'NewParagraph'"></AddParagraph>
            <EditParagraphs @paragraphObj="handleParagraphObj"
                v-if="paragraphObj === null && slotName === 'Edit Paragraphs'">
            </EditParagraphs>
            <EditParagraph :paragraphObj="this.paragraphObj" v-if="paragraphObj != null && slotName === 'Edit Paragraphs'">
                wfwef</EditParagraph>
        </div>
    </div>
</template>

<style scoped lang="less"></style>